<template>
    <div class="custom-list-view" v-if="!withUser && !groupByApp">
        <EmptyListItem v-if="!profiles || profiles.length == 0" />
        <UserProfileListItem v-for="profile in profiles" :profile="profile" :key="profile.id" :user="user"
            @editUsername="showUserApplicationUsernameModal" :withUser="withUser" :withApplication="withApplication"
            :application="profile.application || application" :hideActions="hideActions" />
    </div>
    <div class="custom-list-view" v-else-if="!withApplication && !groupByApp">
        <EmptyListItem v-if="!userProfiles || userProfiles.length == 0" />
        <UserProfileListItem @updated="$emit('updated', $event)" v-for="userProfile in userProfiles"
            @editUsername="showUserApplicationUsernameModal" :user="userProfile.user"
            :application="application || userProfile.profile.application"
            :key="`${userProfile.user.id}|${userProfile.profile.id}`" :profile="userProfile.profile"
            :withUser="withUser" :withApplication="withApplication" :hideActions="hideActions"
            :isPendingApproved="userProfile.is_pending_approval" :groupByApp="groupByApp" />

    </div>
    <div class="custom-list-view" v-else-if="groupByApp">
        <EmptyListItem v-if="!profilesGroupByApp || profilesGroupByApp.length == 0" class="" />
        <div v-for="(profiles, applicationName) in profilesGroupByApp" :key="applicationName" class="border-bottom">
            <UserProfileListItem v-for="(profile, profileIndex) in profiles" :profile="profile" :key="profile.id"
                :user="user" @editUsername="showUserApplicationUsernameModal" :withUser="withUser"
                :withApplication="withApplication" :application="profile.application || application"
                :hideActions="hideActions" :groupByApp="groupByApp" :showValue="profileIndex === 0"
                @updated="$emit('updated', $event)" />
        </div>
    </div>
    <UserApplicationUsernameModal ref="UserApplicationUsernameModal" @updated="$emit('updated', $event)" />
</template>

<script>
import EmptyListItem from "@/components/common/list/EmptyListItem.vue";
import UserApplicationUsernameModal from "@/components/userApplicationUsername/UserApplicationUsernameModal.vue";
import UserProfileListItem from "@/components/userProfile/UserProfileListItem.vue";

export default {
    components: {
        EmptyListItem,
        UserApplicationUsernameModal,
        UserProfileListItem,
    },
    data() {
        return {
            profilesGroupByApp: {},
        };
    },
    emits: ['updated', 'deleted', 'updating'],
    props: {
        loading: Boolean,
        withUser: {
            type: Boolean,
            default: false,
        },
        withApplication: {
            type: Boolean,
            default: true,
        },
        application: {
            type: Object,
        },
        user: {
            type: Object,
            default() {
                return {};
            },
        },
        profiles: {
            type: Array,
            default() {
                return [];
            },
        },
        userProfiles: {
            type: Array,
            default() {
                return [];
            },
        },
        hideActions: {
            type: Boolean,
            default: false,
        },
        groupByApp: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        getExpireAt(profile) {
            if (!this.withUser) {
                let externalUserProfile = this.user.externalUserProfiles.find((up) => up.profile.id == profile.id);
                if (!externalUserProfile) return;

                return externalUserProfile.expires_at;
            } else if (!this.withApplication) {
                return profile.expires_at;
            } else {
                return;
            }
        },
        showUserApplicationUsernameModal(userProfile) {
            if (!this.$refs.UserApplicationUsernameModal) return;
            this.$refs.UserApplicationUsernameModal.show(userProfile.user.id, userProfile.profile.application.id);
        },
    },
    created() {
        if (this.groupByApp) {
            const sortedData = this.profiles.sort((a, b) => {
                const appNameA = a.application.name.toLowerCase();
                const appNameB = b.application.name.toLowerCase();

                if (appNameA < appNameB) return -1;
                if (appNameA > appNameB) return 1;

                const nameA = a.name.toLowerCase();
                const nameB = b.name.toLowerCase();

                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;

                return 0;
            });

            sortedData.forEach(profile => {
                if (!this.profilesGroupByApp[profile.application.name]) {
                    this.profilesGroupByApp[profile.application.name] = [];
                }

                this.profilesGroupByApp[profile.application.name].push(profile);
            });
        }
    },
};
</script>